module.exports = __webpack_public_path__ + "img/bot.3c9faac8.svg";